import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  flex: ${props => props.flex || '1'};
  padding: 0 0.5rem;
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
  ${props => props.flexCol && `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  `}
  ${props => (props.flexRow || props.flexCol) && `
    display: flex;
    ${props => props.flexCol && 'flex-direction: column;'}
    align-items: center;
    justify-content: flex-start;
  `}
  ${props => props.centered && `
    display: flex;
    align-items: center;
    justify-content: center;
  `}
  @media (max-width: 700px) {
    margin: 1.25rem;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export default class Cell extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Row/Cell.js